import { type Bucket, BUCKETS } from '../types';

const mapBucketTypeToBuckets = (bucket: Bucket) => {
  switch (bucket) {
    case 'ACCEPT':
      return BUCKETS.ACCEPT;
    case 'INBOX':
      return BUCKETS.INBOX;
    case 'INTERVIEW':
      return BUCKETS.INTERVIEW;
    case 'NOT_SUITABLE':
      return BUCKETS.NOT_SUITABLE;
    case 'OFFER':
      return BUCKETS.OFFER;
    case 'SHORTLIST':
      return BUCKETS.SHORTLIST;
    case 'PRESCREEN':
      return BUCKETS.PRESCREEN;
    default:
      return BUCKETS.UNKNOWN;
  }
};

export default mapBucketTypeToBuckets;
